const hasRealText = (html) => {
  if (!html) return false;
  return html.replace(/<[^>]*>/g, "").trim().length > 0;
};

const validateForP3AndP4 = (data, appOptionsAvailable) => {
  let validInputs = false;
  let inputRequiredFor = "";
  let postmortemStep = "";
  let postmortemPage = "";

  if (!hasRealText(data.incidentSummaryState.incSummDescription)) {
    validInputs = false;
    inputRequiredFor = "Incident Summary";
    postmortemStep = 0;
    postmortemPage = "Incident Summary";
    return {
      validInputs,
      inputRequiredFor,
      postmortemStep,
      postmortemPage,
    };
  } else if (
    // data.PreventiveAndCorrectiveMeasuresState.trackingMethod === "Jira" &&
    data.PreventiveAndCorrectiveMeasuresState.jiraTickets.length === 0 &&
    data.PreventiveAndCorrectiveMeasuresState.pTasks.length === 0
  ) {
    validInputs = false;
    inputRequiredFor = "Preventive and Corrective Measures";
    postmortemStep = 2;
    postmortemPage = "Preventive and Corrective Measures";
    return {
      validInputs,
      inputRequiredFor,
      postmortemStep,
      postmortemPage,
    };

    // } else if (
    //   data.PreventiveAndCorrectiveMeasuresState.trackingMethod === "PTask" &&
    //   data.PreventiveAndCorrectiveMeasuresState.pTasks.length === 0
    // ) {
    //   validInputs = false;
    //   inputRequiredFor = "Preventive and Corrective Measures";
    //   postmortemStep = 2;
    //   postmortemPage = "Preventive and Corrective Measures";
    //   return {
    //     validInputs,
    //     inputRequiredFor,
    //     postmortemStep,
    //     postmortemPage,
    //   };
  } else if (!data.portfolio.value) {
    validInputs = false;
    inputRequiredFor = "Platform Portfolio";
    postmortemStep = 2;
    postmortemPage = "Mac Data";
    return {
      validInputs,
      inputRequiredFor,
      postmortemStep,
      postmortemPage,
    };
  } else if (!data.platform.value) {
    validInputs = false;
    inputRequiredFor = "Platform";
    postmortemStep = 2;
    postmortemPage = "Mac Data";
    return {
      validInputs,
      inputRequiredFor,
      postmortemStep,
      postmortemPage,
    };
  } else if (!data.product.value) {
    validInputs = false;
    inputRequiredFor = "Product";
    postmortemStep = 2;
    postmortemPage = "Mac Data";
    return {
      validInputs,
      inputRequiredFor,
      postmortemStep,
      postmortemPage,
    };
  }
  if (appOptionsAvailable) {
    if (!data.app.value) {
      validInputs = false;
      inputRequiredFor = "Application";
      postmortemStep = 2;
      postmortemPage = "Mac Data";
      return {
        validInputs,
        inputRequiredFor,
        postmortemStep,
        postmortemPage,
      };
    }
  }

  // MVC Vulnerability Related is optional now; no mandatory validation here.

  validInputs = true;
  inputRequiredFor = "";
  postmortemStep = 0;
  postmortemPage = "Incident Summary";
  return {
    validInputs,
    inputRequiredFor,
    postmortemStep,
    postmortemPage,
  };
};

const hasValidOldFiveWhys = (questions) => {
  if (!questions || questions.length === 0) return false;
  const filled = questions.filter((q) => q?.question?.trim() && q?.answer?.trim());
  return filled.length >= 5;
};

export const validateInputs = (data, appOptionsAvailable, chainedFiveWhysCount = 0) => {
  let validInputs = false;
  let inputRequiredFor = "";
  let postmortemStep = "";
  let postmortemPage = "";

  if (data.priority !== "1" && data.priority !== "2") {
    return validateForP3AndP4(data, appOptionsAvailable);
  }
  if (
    !hasRealText(data.incidentSummaryState.incSummDescription)
  ) {
    validInputs = false;
    inputRequiredFor = "incident Summary";
    postmortemStep = 0;
    postmortemPage = "Incident Summary";
    return {
      validInputs,
      inputRequiredFor,
      postmortemStep,
      postmortemPage,
    };
  } else if (
    !hasValidOldFiveWhys(data.RootCauseIdentificationState.questions) &&
    chainedFiveWhysCount === 0 &&
    !hasRealText(data.RootCauseIdentificationState.description)
  ) {
    return { validInputs: false, inputRequiredFor: "Root Cause Identification", postmortemStep: 1, postmortemPage: "Root Cause Identification (add a description or complete the classic / chained 5 Whys)" };
  } else if (
    !hasValidOldFiveWhys(data.RootCauseIdentificationState.questions) &&
    chainedFiveWhysCount === 0
  ) {
    return { validInputs: false, inputRequiredFor: "5 Whys", postmortemStep: 1, postmortemPage: "Root Cause Identification (add at least one 5 Why chain or complete the classic 5 Whys)" };
  } else if (!data.RootCauseState.rootCauseCode || !data.RootCauseState.rootCauseSubCode) {
    return { validInputs: false, inputRequiredFor: "Root Cause Code", postmortemStep: 1, postmortemPage: "Root Cause Code" };
  } else if ((data.RootCauseState.impactedByChange === true || data.RootCauseState.impactedByChange === "true") && !data.RootCauseState.causedByChangeNumber) {
    return { validInputs: false, inputRequiredFor: "Change Number", postmortemStep: 1, postmortemPage: "Root Cause Code (Change Number required)" };
  } else if (data.RecurrenceState.recurringIssue && !data.RecurrenceState.incidentId) {
    return { validInputs: false, inputRequiredFor: "Recurrence", postmortemStep: 1, postmortemPage: "Root Cause Code (Incident ID required for recurrence)" };
  } else if (
    // data.PreventiveAndCorrectiveMeasuresState.trackingMethod === "Jira" &&
    data.PreventiveAndCorrectiveMeasuresState.jiraTickets.length === 0 &&
    data.PreventiveAndCorrectiveMeasuresState.pTasks.length === 0
  ) {
    validInputs = false;
    inputRequiredFor = "Preventive and Corrective Measures";
    postmortemStep = 2;
    postmortemPage = "Preventive and Corrective Measures";
    return {
      validInputs,
      inputRequiredFor,
      postmortemStep,
      postmortemPage,
    };

    // } else if (
    //   data.PreventiveAndCorrectiveMeasuresState.trackingMethod === "PTask" &&
    //   data.PreventiveAndCorrectiveMeasuresState.pTasks.length === 0
    // ) {
    //   validInputs = false;
    //   inputRequiredFor = "Preventive and Corrective Measures";
    //   postmortemStep = 2;
    //   postmortemPage = "Preventive and Corrective Measures";
    //   return {
    //     validInputs,
    //     inputRequiredFor,
    //     postmortemStep,
    //     postmortemPage,
    //   };
  } else if (!data.portfolio.value) {
    validInputs = false;
    inputRequiredFor = "Platform Portfolio";
    postmortemStep = 2;
    postmortemPage = "Mac Data";
    return {
      validInputs,
      inputRequiredFor,
      postmortemStep,
      postmortemPage,
    };
  } else if (!data.platform.value) {
    validInputs = false;
    inputRequiredFor = "Platform";
    postmortemStep = 2;
    postmortemPage = "Mac Data";
    return {
      validInputs,
      inputRequiredFor,
      postmortemStep,
      postmortemPage,
    };
  } else if (!data.product.value) {
    validInputs = false;
    inputRequiredFor = "Product";
    postmortemStep = 2;
    postmortemPage = "Mac Data";
    return {
      validInputs,
      inputRequiredFor,
      postmortemStep,
      postmortemPage,
    };
  }
  if (appOptionsAvailable) {
    if (!data.app.value) {
      validInputs = false;
      inputRequiredFor = "Application";
      postmortemStep = 2;
      postmortemPage = "Mac Data";
      return {
        validInputs,
        inputRequiredFor,
        postmortemStep,
        postmortemPage,
      };
    }
  }

  // MVC Vulnerability Related is optional now; no mandatory validation here.

  validInputs = true;
  inputRequiredFor = "";
  postmortemStep = 0;
  postmortemPage = "Incident Summary";
  return {
    validInputs,
    inputRequiredFor,
    postmortemStep,
    postmortemPage,
  };
};
